// extracted by mini-css-extract-plugin
export default {"title":"styles_title__ZRvIg","subtitle":"styles_subtitle__HB57B","buttons":"styles_buttons__qIlfe","cancelBtn":"styles_cancelBtn__RMku8","confirmBtn":"styles_confirmBtn__8vDEj"};